import { getConfig } from '../config';
import { COUNTRY_DOMAINS } from './constants';

export const isSingaporeCountry = (): boolean =>
  (getConfig().COUNTRY || COUNTRY_DOMAINS.default).toLowerCase() ===
  COUNTRY_DOMAINS.sg;
